export const MERCHANT_ID = 'af807dfa-a3f7-4676-88ba-62b2412e01df';
export const ELEMENT_ID = 'friendbuy-js-';
